export default __webpack_public_path__ + "ba975db9041b390b9e3f999989a24050.svg";